import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//api
import { deleteDelivery } from 'api/company';
import { getDeliveries } from 'api/pathForHook/company';
//helpers
import { capitalize } from 'helpers';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import Button from 'components/backoffice/buttonCustom';
import Title from 'components/backoffice/texts/title';
import { usePermissions } from 'components/backoffice/PermissionsContext';
import FiltersTableDeliveries from './FiltersTableDeliveries';

const Deliveries = () => {
  const userPermissions = usePermissions();
  const navigate = useNavigate();
  const { t } = useTranslation(['backoffice']);
  const [listDeliveries, setListDeliveries] = useState([]);
  const [page, setPage] = useState(1);
  const [formFilter, setFormFilter] = useState({});
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [responseInfo, setResponseInfo] = useState({});
  const [idItem, setIdItem] = useState();
  const { setTitle } = useOutletContext()

  const colsDeliveries = [
    t('postalcode'),
    t('province'),
    t('notDelivered'),
    `${t('longitude')} ${t('postalcode').toLowerCase()}`,
    t('actions')
  ];

  const { fetchData, stateData, loading } = useHandleSearch();

  const getListDeliveries = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        postal_codes: formFilter.postal_codes || '',
        province: formFilter.province || '',
        fields: 'id,postal_codes,province_name,not_delivered,postal_code_length'
      }
      await fetchData(getDeliveries(), payload);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    setTitle(t('deliveries'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setListDeliveries(results);
      setResponseInfo({ errors, totalPages, noResults })
    } else {
      setListDeliveries(null);
      setResponseInfo({ errors })
    }
  }, [stateData])

  useEffect(() => {
    getListDeliveries();
  }, [page, formFilter]);

  const handleCreate = () => navigate(`/intranet/deliveries/create`);
  const handleEdit = (id) => navigate(`/intranet/deliveries/edit/${id}`);

  const handleShowModalDelete = (item, id, setOpenModal) => {
    if (item.id === id) {
      setOpenModal(true);
      setIdItem(id);
    }
  };

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteDelivery(idItem);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        getListDeliveries()
      } else {
        toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
      }
    } catch (error) {
    }
  }, [showModalDelete]);

  const handleClear = () => {
    setFormFilter({
      postal_codes: '',
      province: '',
    });
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }))
    getListDeliveries();
  };

  return (
    <div className="d-lg-grid">
      <Title text={t('deliveries')} />
      <Row className="d-flex w-md-100 mt-3">
      <Col md={9} xs={12} className="d-flex text-start">
          <FiltersTableDeliveries
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            handleClear={handleClear}
            t={t}
            page={page}
            setPage={setPage}
          />
        </Col>
        <Col md={3} xs={12} className="d-flex text-end align-bottom p-md-0 justify-content-end pt-5 pt-md-0">
          {userPermissions.includes('empresa.__add') && (
            <Button color="primary" onClick={handleCreate}>
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsDeliveries}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {listDeliveries &&
            listDeliveries.map((delivery, index) => {
              return (
                <tr key={delivery.id}>
                  <td>{delivery.postal_codes}</td>
                  <td>{capitalize(delivery.province_name)}</td>
                  <td>{delivery.not_delivered ? t('si') : t('no')}</td>
                  <td>{delivery.postal_code_length}</td>
                  <td className="item-dropdown text-end">
                    <DropdownIcons
                      idItem={index}
                      handleEdit={
                        userPermissions.includes('empresa.__modify')
                        && (() => handleEdit(delivery.id))
                      }
                      handleDelete={
                        userPermissions.includes('empresa.__delete')
                        && (() => handleShowModalDelete(delivery, delivery.id, setShowModalDelete))
                      }
                    />
                  </td>
                </tr>
              );
            })}
        </CustomTable>
      </div>
      <DeleteModalCustom
        openModal={showModalDelete}
        setOpenModal={setShowModalDelete}
        handleDelete={handleDelete}
        deleteTitle={t('deletedelivery')}
        beforeTitle={t('deliveries')}
      />
    </div>
  );
};

export default Deliveries;
